import React from 'react';
import { Box, Tabs, Tab } from '@material-ui/core';
import { scrollToElement } from 'menus/providers/MenuScrollListenerProvider/scrolling-utils';
import { useMenuScrollListener } from '../../providers/MenuScrollListenerProvider';
import { styles } from './SubCategoriesNavigation.styles';

const SubCategoriesNavigation = () => {
  const classes = styles();

  const { selectedSubcategory, selectedCategory } = useMenuScrollListener();

  return (
    <Box className={classes.subCategoriesBar}>
      <Tabs
        className={classes.scrollBar}
        data-testid="menuSubCategoriesBar"
        value={selectedSubcategory.id}
        variant="scrollable"
        scrollButtons="off"
        aria-label="Menu subcategories navigation"
        TabIndicatorProps={{
          style: {
            display: 'none',
          },
        }}
      >
        {selectedCategory.subCategories.map(({ name, id, ref }) => (
          <Tab
            key={id}
            component="button"
            onClick={scrollToElement(ref)}
            data-testid="category-button"
            label={name}
            value={id}
            classes={{
              root: classes.subCategory,
              selected: classes.subCategorySelected,
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default SubCategoriesNavigation;
